export const FEATURED = '/api/appstore/featured';

export const ALL = '/api/appstore';

export const APP_DETAIL = (appID) => `/api/appstore/app/${appID}`;

export const CONNECTOR_DETAIL = (connectorID) => `/api/appstore/connector/${connectorID}`;

export const AWS_DATA_EXCHANGE = '/api/appstore/aws/listings';

export const AWS_FILTERS = '/api/appstore/aws/filters';

export const AWS_SEARCH = '/api/appstore/aws/search';
